<div
  #viewport
  class="tr-list"
  [style.max-height]="viewportHeight"
  data-testid="tr-list"
>
  <ul class="tr-list__records" *ngIf="rows.length; else empty">
    <ng-container *ngFor="let row of rows; let i = index; trackBy: trackByRow">
      <!--
        Group heading (reservations' day boundaries). A heading is a list item of
        its own rather than a wrapper, so one flat list keeps every record at the
        same level for assistive tech and for scroll position.
      -->
      <li
        *ngIf="groupDir && isGroupBoundary(i)"
        class="tr-list__group"
        role="presentation"
        data-testid="tr-list-group"
      >
        <ng-container
          *ngTemplateOutlet="groupDir.template; context: { $implicit: row, groupKey: groupKeyAt(i), index: i }"
        ></ng-container>
      </li>

      <li
        [attr.id]="rowIdFor(row)"
        class="tr-list__record"
        [ngClass]="rowClassFor(row)"
        [class.party-highlight]="isHighlighted(row)"
        [class.tr-list__record--hidden]="isRowHidden(row)"
        data-testid="tr-list-record"
      >
        <div
          *ngFor="let col of columns; trackBy: trackByColKey"
          class="tr-list__field"
          [ngClass]="col.cellClass"
          [attr.data-col]="col.key"
          [attr.data-testid]="'tr-list-field-' + col.key"
        >
          <span *ngIf="showLabel(col)" class="tr-list__label">{{ col.header | titlecase }}:</span>

          <div class="tr-list__value">
            <!--
              `listMode` in the context lets a cell drop chrome that only earns its
              keep in a column — a fixed-height placeholder that keeps rows aligned
              is just a blank line here. Cells that ignore it render unchanged.
            -->
            <ng-container *ngIf="cellTemplates.get(col.templateKey || col.key) as cellDir; else defaultCell">
              <ng-container
                *ngTemplateOutlet="
                  cellDir.template;
                  context: {
                    $implicit: row,
                    index: i,
                    column: col,
                    listMode: true,
                    visibleKeys: visibleKeys
                  }
                "
              ></ng-container>
            </ng-container>
            <ng-template #defaultCell>{{ fieldValue(row, col.field) }}</ng-template>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>

  <ng-template #empty>
    <p class="tr-list__empty" data-testid="tr-list-empty">{{ emptyMessage }}</p>
  </ng-template>
</div>
